import { withAuthenticationRequired } from '@auth0/auth0-react';

import { IS_E2E } from '@omnipresentgroup/constants';

export const PrivateRoute = (route: React.ComponentType<object>) => {
  const ProtectedOutlet = withAuthenticationRequired(route);

  const Route = IS_E2E ? route : ProtectedOutlet;

  return <Route />;
};
